import { render, staticRenderFns } from "./NcpColGroup.vue?vue&type=template&id=4c252c86&"
import script from "./NcpColGroup.vue?vue&type=script&lang=ts&"
export * from "./NcpColGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports